<template>
    <FormSelect v-bind="$attrs" :value="selectedMaterial" :label="label" @input="handleInput">
        <option
            v-for="material in materials"
            :key="material.id"
            :value="material.id"
        >{{ material.name }}</option>
    </FormSelect>
</template>


<script>
import { mapState } from 'vuex';

export default {
    name: 'FormSelectMaterial',
    inheritAttrs: false,

    props: {
        value: { type: Number },
        label: { type: String, default: 'Material' },
    },

    computed: {
        ...mapState('company', ['materials']),
        selectedMaterial() {
            const id = this.value?.id;
            return id ? Number.parseInt(id, 10) : this.value;
        },
    },

    methods: {
        handleInput(value) {
            const id = Number.parseInt(value, 10);
            this.$emit('input', Number.isFinite(id) ? id : null);
        },
    },
};
</script>
